// Theme configuration for Johns Hopkins Hillel website
// Using official Johns Hopkins colors from https://teamcolorcodes.com/johns-hopkins-university-blue-jays-color-codes/

export const theme = {
  colors: {
    // Primary brand colors
    primary: '#002D72', // Hopkins Blue
    primaryLight: '#68ACE5', // Hopkins Light Blue
    // Secondary brand colors
    secondary1: '#0077D8',
    secondary2: '#4E97E0',
    secondary3: '#86C8BC',
    secondary4: '#008767',
    secondary5: '#275E3D',
    secondary6: '#76A04C',
    secondary7: '#9E8FB0',
    secondary8: '#51284F',
    secondary9: '#A45C98',
    // Accent colors (use sparingly)
    accentYellow: '#F1C400',
    accentOrange: '#FF9E1B',
    accentOrange2: '#F56600',
    accentRed: '#CF4520',
    accentRed2: '#A6192E',
    accentRed3: '#6A202B',
    accentGold: '#CBA052',
    accentBrown: '#964F2E',
    accentBrown2: '#4F2C1D',
    accentPeach: '#E8927C',
    // UI colors
    background: '#f6f9fc',
    card: '#fff',
    text: {
      primary: '#002D72',
      secondary: '#425466',
      light: '#fff',
      dark: '#0a2540',
    },
    border: '#e3e8ee',
  },
  gradients: {
    blue: 'linear-gradient(90deg, #002D72 0%, #2477ff 100%)',
    blueGreen: 'linear-gradient(90deg, #002D72 0%, #68ACE5 100%)',
    blueAccent: 'linear-gradient(90deg, #002D72 0%, #2477ff 100%)',
    hero: 'linear-gradient(90deg, #002D72 0%, #2477ff 100%)',
  },
  typography: {
    fontFamily: {
      primary: '"Inter", "Open Sans", Arial, sans-serif',
      secondary: '"Playfair Display", serif',
    },
    fontSize: {
      h1: '3.5rem',
      h2: '2.5rem',
      h3: '2rem',
      h4: '1.5rem',
      body: '1rem',
      small: '0.875rem',
    },
    fontWeight: {
      light: 300,
      regular: 400,
      medium: 500,
      bold: 700,
      extrabold: 900,
    },
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  breakpoints: {
    xs: '0px',
    sm: '600px',
    md: '960px',
    lg: '1280px',
    xl: '1920px',
  },
  // Common component styles
  components: {
    button: {
      borderRadius: '999px',
      padding: '1rem 2.5rem',
      fontWeight: 700,
      fontSize: '1.25rem',
      boxShadow: '0 4px 24px rgba(0,45,114,0.10)',
      transition: 'background 0.2s, color 0.2s',
    },
    card: {
      borderRadius: '16px',
      boxShadow: '0 2px 8px rgba(0,45,114,0.08)',
      background: '#fff',
      padding: '2rem',
    },
  },
};

export default theme; 